import React from 'react';
import { Bolt, Cloud, Flame } from 'lucide-react';
import { StepButtons } from '../ui';

interface NetworksStepProps {
  value: {
    networks: {
      electricity: 'good' | 'renovate' | 'unknown';
      plumbing: 'good' | 'renovate' | 'unknown';
      heating: 'good' | 'renovate' | 'unknown';
    };
  };
  onChange: (field: string, value: any) => void;
  onNext: () => void;
  onBack: () => void;
}

export const NetworksStep: React.FC<NetworksStepProps> = ({
  value,
  onChange,
  onNext,
  onBack
}) => {
  const handleNetworkChange = (network: keyof typeof value.networks, state: 'good' | 'renovate' | 'unknown') => {
    onChange('networks', {
      ...value.networks,
      [network]: state
    });
  };

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-semibold text-primary">État des réseaux</h2>
      
      <div className="space-y-6">
        <NetworkCard
          icon={<Bolt className="h-6 w-6" />}
          label="Électricité"
          value={value.networks.electricity}
          onChange={(state) => handleNetworkChange('electricity', state)}
        />
        <NetworkCard
          icon={<Cloud className="h-6 w-6" />}
          label="Plomberie"
          value={value.networks.plumbing}
          onChange={(state) => handleNetworkChange('plumbing', state)}
        />
        <NetworkCard
          icon={<Flame className="h-6 w-6" />}
          label="Chauffage"
          value={value.networks.heating}
          onChange={(state) => handleNetworkChange('heating', state)}
        />
      </div>

      <StepButtons onNext={onNext} onBack={onBack} />
    </div>
  );
};

interface NetworkCardProps {
  icon: React.ReactNode;
  label: string;
  value: 'good' | 'renovate' | 'unknown';
  onChange: (state: 'good' | 'renovate' | 'unknown') => void;
}

const NetworkCard: React.FC<NetworkCardProps> = ({
  icon,
  label,
  value,
  onChange
}) => (
  <div className="card">
    <div className="flex items-center mb-4">
      <div className="text-primary mr-3">{icon}</div>
      <span className="font-medium text-neutral-800">{label}</span>
    </div>
    
    <div className="grid grid-cols-3 gap-2">
      <StateButton
        label="Bon état"
        selected={value === 'good'}
        onClick={() => onChange('good')}
      />
      <StateButton
        label="À rénover"
        selected={value === 'renovate'}
        onClick={() => onChange('renovate')}
      />
      <StateButton
        label="Inconnu"
        selected={value === 'unknown'}
        onClick={() => onChange('unknown')}
      />
    </div>
  </div>
);

interface StateButtonProps {
  label: string;
  selected: boolean;
  onClick: () => void;
}

const StateButton: React.FC<StateButtonProps> = ({ label, selected, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className={`
      py-2 px-3 rounded-md text-sm font-medium transition-all
      ${selected 
        ? 'bg-primary text-white' 
        : 'bg-neutral-100 text-neutral-700 hover:bg-neutral-200'}
    `}
  >
    {label}
  </button>
);

export default NetworksStep;